import { TextField, CircularProgress } from '@mui/material';
import { PrimaryButton } from './component/common';
import { withStyles } from '../mui-styles-bridge.js';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import React, { Component } from 'react';
import UserAccount from './component/UserAccount';
import axios from 'axios';
import config from '../config';
import withNavigate from '../utils/withNavigate';

const styles = (theme) => ({
  wrapper: {
    backgroundImage: 'radial-gradient(rgb(197, 197, 197) 1px, transparent 0px)',
    backgroundSize: '40px 40px',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'fit-content',
    maxWidth: '400px',
    margin: '24px auto',
    padding: '32px',
    borderRadius: '6px',
    border: '1px solid #000',
    background: '#FFF',
    boxShadow: '8px 8px 0px 0px rgba(0, 0, 0, 0.25)',
  },
  logo: {
    height: 'auto',
    minHeight: '40px',
    maxWidth: '100%',
    marginBottom: '20px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'normal',
    marginBottom: '10px',
    textAlign: 'center',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    flexGrow: 1,
    marginRight: '10px',
  },
  button: {
    minWidth: '40px',
    height: '40px',
    padding: '0',
  },
});

class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = { form_id: '', logged: false, loadingScreen: false };
  }
  componentDidMount() {
    this.setState({
      loadingScreen: true,
    });

    // Check if user is returning from unified login
    this.checkForReturnFromUnifiedLogin();

    let formURL = null;
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'customOAuthState':
          formURL = data.payload.data;
          break;
        default:
          break;
      }
    });

    fetchAuthSession()
      .then(async (session) => {
        if (session.tokens?.idToken) {
          let idToken = session.tokens.idToken.toString();
          if (idToken) {
            // Add timeout to prevent hanging
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            try {
              const res = await axios.post(
                `${config.USER_ADDRESS}/check-user-verified-and-completed`,
                '',
                {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: idToken,
                  },
                  signal: controller.signal,
                  timeout: 5000,
                }
              );
              clearTimeout(timeoutId);

              if (res.data) {
                if (!res.data.verified || !res.data.isCompleted) {
                  window.open(config.ADMIN_DASHBOARD_URL, '_blank');
                  if (formURL) {
                    window.location.href = formURL;
                  }
                  this.setState({
                    logged: true,
                  });
                  setTimeout(() => {
                    this.setState({
                      loadingScreen: false,
                    });
                  }, 1000);
                } else {
                  if (formURL) {
                    window.location.href = formURL;
                  }
                  this.setState({
                    logged: true,
                  });
                  setTimeout(() => {
                    this.setState({
                      loadingScreen: false,
                    });
                  }, 1000);
                }
              }
            } catch (error) {
              clearTimeout(timeoutId);
              console.log('API call failed:', error);
              this.setState({
                loadingScreen: false,
                logged: true,
              });
            }
          } else {
            this.setState({
              loadingScreen: false,
            });
          }
        } else {
          // No session, show the form immediately
          this.setState({
            loadingScreen: false,
          });
        }
      })
      .catch((error) => {
        console.log('Auth session failed:', error);
        this.setState({
          loadingScreen: false,
        });
      });
  }

  handleSubmit = () => {
    this.props.history.push(`/form/${this.state.form_id}`);
  };

  checkForReturnFromUnifiedLogin = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const loginSuccess = urlParams.get('loginSuccess');
    const returnUrl = localStorage.getItem('form_return_url');

    if (loginSuccess === 'true') {
      // Clear the stored return URL
      localStorage.removeItem('form_return_url');

      // Clean up URL parameters
      window.history.replaceState({}, document.title, window.location.pathname);

      // If there's a specific form URL to return to, redirect there
      if (returnUrl && returnUrl !== window.location.href) {
        console.log('Redirecting to form after successful login:', returnUrl);
        window.location.href = returnUrl;
        return;
      }

      // Otherwise, refresh to check authentication status
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  render() {
    const { logged } = this.state;

    if (!this.state.loadingScreen) {
      return (
        <div className="verify-wrapper">
          <div className="verify-card">
            <a
              href="https://www.workflow86.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="verify-logo"
                src={'/images/workflow86-logo-text.jpg'}
                alt="Workflow86"
              />
            </a>
            <p className="verify-title">
              Looking for a form? Enter the form ID below
            </p>
            <form className="verify-form" onSubmit={this.handleSubmit}>
              <TextField
                className="verify-input"
                variant="outlined"
                placeholder="Enter form ID"
                value={this.state.form_id}
                onChange={(event) =>
                  this.setState({ form_id: event.target.value })
                }
                size="small"
              />
              <PrimaryButton
                className="verify-button"
                type="submit"
                disabled={!this.state.form_id}
              >
                →
              </PrimaryButton>
            </form>
            
            <div className="verify-divider">
              <span>{logged ? 'Signed in' : 'Account'}</span>
            </div>
            
            {logged ? (
              <div className="verify-user-section">
                <p className="verify-user-label">You are currently logged in as</p>
                <UserAccount />
              </div>
            ) : (
              <p className="verify-signin-text">
                Have an account? <a href={config.ADMIN_DASHBOARD_URL}>Sign in</a>
              </p>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="verify-wrapper">
          <CircularProgress size={50} />
        </div>
      );
    }
  }
}

export default withNavigate(withStyles(styles)(Verify));
